var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getAppConfiguration } from '../Config';
import { Api } from './Core/Api';
export class MakhazinApi extends Api {
    constructor(abortController) {
        super(getAppConfiguration().makhazinApi, abortController);
    }
    authUser(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.post('/authentication/credentials', {
                username: username,
                password: password,
            });
            return result;
        });
    }
    resetPassword(username) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.post(`/authentication/reset-password?username=${encodeURIComponent(username || '')}`, undefined, true);
            return;
        });
    }
    collect(orderRef, autoStart, mobileDevice, invitationToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.get(`/authentication/bankid-collect?invitationToken=${invitationToken ? encodeURI(invitationToken) : undefined}&orderRef=${orderRef}&autoStart=${autoStart}&${mobileDevice}`);
            return result;
        });
    }
    cancel(orderRef) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.post(`/authentication/bankid-cancel?orderRef=${orderRef}`, {}, true);
        });
    }
    auth(personalNumber, reservationId, invitationToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.get(`/authentication/bankid-auth?${reservationId ? `reservationId=${reservationId}` : null}&${invitationToken ? `invitationToken=${encodeURI(invitationToken)}` : null}&${personalNumber ? `personalNumber=${personalNumber}` : ''}`);
            return result;
        });
    }
    generateQrToken(startQrToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.post(`/authentication/bankid-generate-qr`, {
                startQrToken: startQrToken,
            }, false);
            return result;
        });
    }
    validateResetPasswordToken(token) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.get(`/authentication/validate-password-reset?passwordResetToken=${encodeURI(token)}`);
            return result;
        });
    }
    updatePassword(password, confirmPassword, token) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.post(`/authentication/change-password`, { password: password, confirmPassword: confirmPassword, passwordResetToken: token }, true);
        });
    }
}
